import {ShieldX} from "lucide-react";
import {Link, Outlet} from "react-router-dom";
import {getDefaultPathForRole} from "../../../shared/navigation/navigation";
import {canModerateBusinessOnboarding} from "../permissions";
import {useTranslation} from "../../../shared/i18n";


export const OnboardingRouteGuard = ({role, modules}) => {
    const {t} = useTranslation();
    if (canModerateBusinessOnboarding(role)) {
        return <Outlet />;
    }

    return (
        <section className="admin-page" aria-labelledby="onboarding-access-title">
            <div className="admin-card admin-empty-state">
                <ShieldX aria-hidden="true" size={28} />
                <div>
                    <h1 id="onboarding-access-title">{t("sections.onboarding.p129")}</h1>
                    <p>{t("sections.onboarding.p130")}</p>
                </div>
                <Link
                    className="admin-button admin-button-secondary"
                    to={getDefaultPathForRole(role, modules)}
                >
                    {t("sections.onboarding.p131")}
                </Link>
            </div>
        </section>
    );
};
